module.exports = __webpack_public_path__ + "media/images/medal-gold-f50d737aea9c8a97a0d457910d3fce74.svg";